import { FC, useMemo } from 'react';
import { Modal } from 'react-bootstrap';

import { useTranslate } from 'hooks/useTranslate';

import { EncumbrancesImportProgress } from '../utils/importEncumbrancesInBatches';

import './EncumbrancesExcelImportProgress.scss';

type Props = EncumbrancesImportProgress;

const EncumbrancesExcelImportProgress: FC<Props> = ({
  total,
  processed,
  created,
  failed,
}) => {
  const { t } = useTranslate();

  const percentage = useMemo(() => {
    if (!total) {
      return 0;
    }

    return Math.min(100, Math.round((processed / total) * 100));
  }, [processed, total]);

  const remaining = Math.max(total - processed, 0);

  return (
    <Modal.Body className="encumbrances-excel-import-progress">
      <p className="text-soft mb-4">{t('EncumbrancesExcelImportDoNotClose')}</p>
      <h2
        className="encumbrances-excel-import-progress__percentage"
        data-testid="encumbrances-excel-import-percentage"
      >
        {percentage}%
      </h2>
      <div className="progress progress-lg bg-light rounded">
        <div
          className={`progress-bar progress-bar-striped progress-bar-animated ${
            percentage === 100 ? 'bg-success' : 'bg-primary'
          }`}
          data-progress={percentage}
          style={{ width: `${percentage}%` }}
          data-testid="encumbrances-excel-import-progress-bar"
        />
      </div>
      <p className="mt-3 mb-1">
        {t('EncumbrancesExcelImportProgressCount', { processed, total })}
      </p>
      <p className="text-soft mb-4">
        {t('EncumbrancesExcelImportPendingCount', { remaining })}
      </p>
      <ul className="encumbrances-excel-import-progress__stats list-unstyled mb-0">
        <li>
          {t('EncumbrancesExcelImportCreatedCount', { count: created })}
        </li>
        <li>{t('EncumbrancesExcelImportFailedCount', { count: failed })}</li>
      </ul>
    </Modal.Body>
  );
};

export default EncumbrancesExcelImportProgress;
